export enum ogyTrackingEvent {
  OCS_LOADED = 'OCS_loaded'
}

type ExposureChangeCallback = (exposure: number) => void;
type IsViewableCallback = (isViewable: boolean) => void;

export class AdContainer {
  private onExposureChangePointer:
    | ExposureChangeCallback
    | IsViewableCallback
    | undefined;

  constructor(private aWindow: Window) {}

  public open(url: string) {
    if (this.aWindow.mraid && this.aWindow.mraid.open) {
      this.aWindow.mraid.open(url);
      return;
    }

    this.aWindow.open(url, '_blank');
  }

  public unload() {
    if (!this.aWindow.mraid) {
      return;
    }
    if (this.getMraidVersion() >= 3 && this.aWindow.mraid.unload) {
      this.aWindow.mraid.unload();
    } else if (this.aWindow.mraid.close) {
      this.aWindow.mraid.close();
    }
  }

  public getMaxSize(): { width: number; height: number } | null {
    if (
      this.aWindow.mraid &&
      this.aWindow.mraid.getMaxSize &&
      typeof this.aWindow.mraid.getMaxSize === 'function'
    ) {
      const size = this.aWindow.mraid.getMaxSize();
      return { width: size.width, height: size.height };
    }

    return null;
  }

  public isMraidPresent(): boolean {
    return this.aWindow.mraid !== undefined;
  }

  public getDefaultPosition(): { width: number; height: number } | null {
    if (
      this.aWindow.mraid &&
      this.aWindow.mraid.getDefaultPosition &&
      typeof this.aWindow.mraid.getDefaultPosition === 'function'
    ) {
      const position = this.aWindow.mraid.getDefaultPosition();
      return { width: position.width, height: position.height };
    }

    return null;
  }

  public detachExposureChangedListener(): void {
    if (!this.aWindow.mraid) {
      return;
    }

    this.onExposureChangePointer &&
      (this.aWindow.mraid.removeEventListener as any)(
        'exposureChange',
        this.onExposureChangePointer
      );
    this.onExposureChangePointer &&
      (this.aWindow.mraid.removeEventListener as any)(
        'viewableChange',
        this.onExposureChangePointer
      );
  }

  // MRAID fires exposureChange/viewableChange only on a change, never on attach.
  public getCurrentExposure(): number | null {
    if (
      !this.aWindow.mraid ||
      typeof this.aWindow.mraid.isViewable !== 'function'
    ) {
      return null;
    }
    const isViewable = (this.aWindow.mraid.isViewable as () => unknown)();
    return isViewable === true || isViewable === 'true' ? 100 : 0;
  }

  public onExposureChanged(exposureCallback: ExposureChangeCallback): void {
    if (!this.aWindow.mraid) {
      return;
    }
    if (this.getMraidVersion() >= 3) {
      this.onExposureChangePointer = exposureCallback;
      this.aWindow.mraid.addEventListener(
        'exposureChange',
        this.onExposureChangePointer
      );
    } else {
      this.onExposureChangePointer = (isViewable: boolean) => {
        exposureCallback(isViewable ? 100 : 0);
      };
      this.aWindow.mraid.addEventListener(
        'viewableChange',
        this.onExposureChangePointer
      );
    }
  }

  public getMraidVersion(): number {
    return parseFloat(this.aWindow.mraid.getVersion());
  }
}
